<template>
    <button
        :disabled="disabled"
        :type="type"
        class="flex w-full items-center justify-center rounded-md border border-transparent bg-[#088BEA] px-8 py-4 text-lg font-bold text-white transition duration-100 ease-in-out hover:text-gray-100 hover:shadow-button focus:text-gray-100 focus:outline-hidden focus:ring-2 focus:ring-[#088BEA] focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-white"
        @click="(e) => $emit('click', e)"
    >
        <slot />
    </button>
</template>

<script lang="ts" setup>
defineProps({
    /**
     * Is button disabled
     * @values true, false
     */
    disabled: {
        type: Boolean,
        default: false,
    },
    type: {
        type: String as () => "button" | "submit" | "reset" | undefined,
        validator(value: string | undefined) {
            return (
                value === undefined ||
                ["button", "submit", "reset"].includes(value)
            );
        },
        default: undefined,
    },
});

defineEmits(["click"]);
</script>
